<!-- ADD VIRTUAL CARD -->
<p-dialog
  closeOnEscape="false"
  class="filters-modal"
  header="Agregar tarjeta virtual"
  [modal]="true"
  [(visible)]="showAddCard"
  [style]="{ width: '850px' }"
  *ngIf="showAddCard"
  (visibleChange)="exitNewCard()"
>
  <div class="filters-container">
    <div class="loading-add-card" *ngIf="addingCard">
      <app-loading [loadingText]="'Agregando tu tarjeta'" />
    </div>
    <form class="form-container" [formGroup]="newCardForm">
      <div class="form-row">
        <div class="filter-column">
          <div class="input-item">
            <label for="card_holder_name">Alias de la tarjeta</label>
            <input
              pInputText
              formControlName="alias"
              autocomplete="off"
              placeholder="Ingresa el alias de la tarjeta"
            />
          </div>
          <div class="input-item">
            <label for="card_holder_name">Nombre en la tarjeta</label>
            <input
              pInputText
              formControlName="card_holder_name"
              autocomplete="off"
              placeholder="Ingresa el nombre de la persona"
            />
          </div>
        </div>
        <div class="filter-column">
          <div class="input-item">
            <label for="email">Correo electrónico</label>
            <input
              placeholder="Ingresa tu correo electrónico"
              pInputText
              formControlName="email"
              autocomplete="off"
            />
          </div>
          <div class="input-item mixed">
            <label for="phone">Teléfono</label>
            <div class="inputs">
              <p-inputNumber
                formControlName="phone_country_code"
                autocomplete="off"
                [useGrouping]="false"
                class="phone-code"
                prefix="+"
                placeholder="Código"
              />
              <p-inputNumber
                [useGrouping]="false"
                formControlName="phone"
                autocomplete="off"
                placeholder="Número de teléfono"
              />
            </div>
          </div>
        </div>
        <div class="filter-column">
          <div class="input-item">
            <label for="daily_limit">Límite diario</label>
            <p-inputNumber
              currency="USD"
              locale="en-US"
              formControlName="daily_limit"
              autocomplete="off"
              mode="currency"
              placeholder="$0.00"
            />
          </div>

          <div class="input-item">
            <label for="weekly_limit">Límite semanal</label>
            <p-inputNumber
              currency="USD"
              locale="en-US"
              formControlName="weekly_limit"
              autocomplete="off"
              mode="currency"
              placeholder="$0.00"
            />
          </div>
          <div class="input-item">
            <label for="monthly_limit">Límite mensual</label>
            <p-inputNumber
              currency="USD"
              locale="en-US"
              formControlName="monthly_limit"
              autocomplete="off"
              mode="currency"
              placeholder="$0.00"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="filter-column wallet-column">
          <div class="input-item">
            <label for="wallet_id">Wallet USDT para el fee</label>
            <p-dropdown
              inputId="wallet_id"
              placeholder="Elige la wallet crypto desde la que se cobra la creación"
              formControlName="wallet_id"
              [options]="wallets"
              optionLabel="wallet_shortname"
              [filter]="true"
              filterBy="wallet_shortname,shortname,id"
              [style]="{ width: '100%' }"
              appendTo="body"
            />
          </div>
          <div class="card-fee-summary">
            <small class="p-text-secondary" *ngIf="loadingCreateFee">
              Consultando fee de creación...
            </small>
            <small class="card-fee-error" *ngIf="createFeeError">
              {{ createFeeError }}
            </small>
            <ng-container *ngIf="!loadingCreateFee && !createFeeError && createFeeAmount !== null">
              <div class="card-fee-row card-fee-total">
                <span>Fee de creación</span>
                <strong>{{ formattedCreateFee() }}</strong>
              </div>
              <small class="card-fee-note">
                Este monto se toma del fee de creación de tarjeta configurado
                para tu cuenta.
              </small>
            </ng-container>
          </div>
        </div>
      </div>
    </form>
    <div class="disclaimer">
      <div class="title">
        <i class="pi pi-exclamation-circle"></i>
        Información Importante
      </div>

      La creación de una tarjeta virtual genera un cargo automático de
      <b>{{ formattedCreateFee() || 'USDT' }}</b> desde el wallet que
      selecciones. Si ese wallet no tiene fondos suficientes, la tarjeta no
      podrá ser creada.
      <br /><br />
      Asimismo, el <b>correo electrónico</b> y el
      <b>número telefónico</b> proporcionados serán utilizados para la
      validación de la tarjeta y para la consulta de su información, por lo que
      deben ser datos reales y correctos.
    </div>
  </div>
  <div class="buttons-container">
    <p-button label="Cancelar" severity="danger" (click)="exitNewCard()" />
    <p-button
      label="Guardar tarjeta"
      [disabled]="!canSubmitCard()"
      [loading]="addingCard"
      severity="secondary"
      (click)="confirmSaveCard($event)"
    />
  </div>
</p-dialog>
